import { render, staticRenderFns } from "./CommentaryPlusEditor.vue?vue&type=template&id=0021251f&scoped=true"
import script from "./CommentaryPlusEditor.vue?vue&type=script&lang=js"
export * from "./CommentaryPlusEditor.vue?vue&type=script&lang=js"
import style0 from "./CommentaryPlusEditor.vue?vue&type=style&index=0&id=0021251f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021251f",
  null
  
)

export default component.exports